import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CdsInputsModule } from '@celerofinancas/design-system';
import { TooltipDirective } from '@celerofinancas/ui-directives';

import { InfoCardComponent } from '@shared/info-card/info-card.component';
import { InfoNotice } from '@shared/models/info-notice';

/**
 * GetNet design system showcase — replaces the prototype in client validation.
 */
@Component({
  selector: 'getnet-webcomponent-design-system',
  standalone: true,
  imports: [CdsInputsModule, TooltipDirective, InfoCardComponent],
  templateUrl: './design-system.component.html',
  styleUrls: ['./design-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesignSystemComponent {
  /**
   * Two notices for the info card, so the showcase exercises what the dashboard cannot.
   *
   * The dashboard has a single notice today (see `configs/info-notices.ts`), which by
   * design is a static block: no dots and no rotation. The carousel is only visible with
   * more than one, and this is the screen for looking at components.
   *
   * The call to action does nothing on purpose. It is here to show that a notice can
   * carry one, on a screen whose whole job is showing what the pieces look like.
   */
  public readonly infoNotices: InfoNotice[] = [
    {
      id: 'monthly-report',
      title: 'Confira o desempenho mensal do seu negócio!',
      body: [{ text: 'Seu relatório DFM (Demonstrativo Financeiro Mensal) de Agosto já está disponível para consulta.' }],
    },
    {
      id: 'open-finance',
      title: 'Conecte todas as suas contas bancárias.',
      body: [
        { text: 'Traga suas contas de outros bancos pelo ' },
        { text: 'Open Finance', emphasis: true },
        { text: ' e acompanhe tudo em um lugar.' },
      ],
      cta: { label: 'Conectar Open Finance', action: () => undefined },
    },
  ];
}
